const tariffs = require('./bookTariffs');
const stripeTariffs = require('./stripebookTariffs');
const officeEmployeePermissions = require('./officeEmployeePermissions');
const orgEmployeePermissions = require('./orgEmployeePermissions');
const bookTariffTypePermissions = require('./bookTariffTypePermissions');
const permissions = require('./permissions');
const tariffStatus = require('./bookTariffStatus');
const accountType = require('./accountType');
const appConstants = require('./appConstants');
const currency = require('./currency');
const smsPackages = require('./smsPackages');
const editTermsStrategy = require('./editTermsStrategy');
const thePayPaymentStatus = require('./thePayPaymentStatus');
const frequencyType = require('./frequencyType');
const userRegistrationStatus = require('./userRegistrationStatus');
const reservationStates = require('./reservationStates');
const paymentForType = require('./paymentForType');
const pricingOptionType = require('./pricingOptionType');
const paymentCategory = require('./paymentCategory');
const smsService = require('./smsService');
const minimalAmountsToBeCharged = require('./minimalAmountsToBeCharged');
const frequencyPeriod = require('./frequencyPeriod');
const lectureInstanceStatus = require('./lectureInstanceStatus');
const organisationClientStatus = require('./organisationClientStatus');
const organisationType = require('./organisationType');
const appLanguages = require('./appLanguages');
const termsTypes = require('./termsTypes');
const billingEntityType = require('./billingEntityType');
const tariffBitPermissions = require('./tariffBitPermissions');
const organisationUserRoles = require('./organisationUserRoles');
const officeUserRoles = require('./officeUserRoles');
const userSystemStatus = require('./userSystemStatus');
const paymentStatus = require('./paymentStatus');
const stripePaymentStatus = require('./stripePaymentStatus');
const paymentMethod = require('./paymentMethod');
const licensePaymentMethod = require('./licensePaymentMethod');
const licensePaymentStatus = require('./licensePaymentStatus');
const paymentMethodGroupTypes = require('./paymentMethodGroupTypes');
const notificationMessages = require('./notificationMessages');
const asyncValidationType = require('./asyncValidationType');
const asyncValidationField = require('./asyncValidationField');
const rpcQueues = require('./rpcQueues');
const emailTypes = require('./emailTypes');
const noteType = require('./noteType');
const entranceValidityTimeUnit = require('./entranceValidityTimeUnit');
const timeUnit = require('./timeUnit');
const orderType = require('./orderType');
const statsType = require('./statsType');
const stornoPaymentStatus = require('./stornoPaymentStatus');
const clientHistoryType = require('./clientHistoryType');
const clientHistoryText = require('./clientHistoryText');
const mailerEmailType = require('./mailerEmailType');
const cancelReservationOfficeChoice = require('./cancelReservationOfficeChoice');
const reservedFrontendUrls = require('./reservedFrontendUrls');
const tariffLengths = require('./tariffLengths');
const creditPassSystemStatus = require('./creditAndPassSystemStatus');
const currencyEuHelper = require('./currencyEuHelper');
const promoVoucherType = require('./promoVoucherType');
const promoCodeStrategy = require('./promoCodeStrategy');

module.exports = {
    promoVoucherType,
    promoCodeStrategy,
    tariffs,
    stripeTariffs,
    timeUnit,
    entranceValidityTimeUnit,
    noteType,
    billingEntityType,
    tariffStatus,
    officeEmployeePermissions,
    orgEmployeePermissions,
    bookTariffTypePermissions,
    permissions,
    currency,
    smsPackages,
    editTermsStrategy,
    frequencyType,
    userRegistrationStatus,
    reservationStates,
    pricingOptionType,
    paymentCategory,
    frequencyPeriod,
    lectureInstanceStatus,
    organisationClientStatus,
    organisationType,
    termsTypes,
    tariffBitPermissions,
    organisationUserRoles,
    officeUserRoles,
    userSystemStatus,
    paymentStatus,
    stripePaymentStatus,
    paymentMethod,
    licensePaymentMethod,
    licensePaymentStatus,
    paymentMethodGroupTypes,
    notificationMessages,
    asyncValidationType,
    asyncValidationField,
    rpcQueues,
    orderType,
    stornoPaymentStatus,
    clientHistoryType,
    clientHistoryText,
    mailerEmailType,
    cancelReservationOfficeChoice,
    reservedFrontendUrls,
    tariffLengths,
    statsType,
    emailTypes,
    creditPassSystemStatus,
    appLanguages,
    minimalAmountsToBeCharged,
    appConstants,
    accountType,
    smsService,
    thePayPaymentStatus,
    currencyEuHelper,
    paymentForType,
};
